// Vidéos du site. Fichiers dans public/videos/.
// Pour changer une vidéo : déposer le nouveau fichier dans public/videos/
// (16:9, 5 à 10 s, sans son) et mettre son nom ci-dessous.
const P = `${process.env.PUBLIC_URL || ""}/videos`;

export const VIDEO = {
  hero: `${P}/entrada.mp4`, // porte d'entrée → intérieur (sans personne), section de fin
  heroMobile: `${P}/entrada-mobile.mp4`,
  preparacion: `${P}/sandwish.mp4`, // tostada qui se monte toute seule, milieu de page
  preparacionMobile: `${P}/sandwish-mobile.mp4`,
};
